import React, { FC } from 'react';
import { SearchSelectProps } from '../search_select/search_select';

import AddButtonE from '../buttons/add-button';
import styled from '../../../theme';
import Checkbox from "../../../ui_components/checkbox/checkbox";

export interface HeaderProps {
  headingText: string;
  addButtonText: string;
  inactiveFilter: boolean;
  onSearch: SearchSelectProps['onSearch'];
  onItemClick(id: number): void;
  onInactiveFilterChange(inactive: boolean): void;
  onAddClick?(): void;
  showDropdown?: boolean;
  openDropdown?(): void;
  dropdownState?: boolean;
  clickImportClients?(): void;
  showAddButton?: boolean;
}

const AddButton = styled(AddButtonE)`
  margin-left: auto;
  // @media screen and (max-width: 992px) {
  //     padding: 0px;
  // }
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 5px;
  // margin-top: -15px;
`;

const IncludeInactiveCheckBox = styled(Checkbox)`
  font-size: 14px !important;
  color: #222 !important;
  padding-left: 10px !important;
`;

const Heading = styled.h1`
  font-family: 'Poppins', serif !important;
  font-size: 18px !important;
  letter-spacing: 0px !important;
  margin-right: 15px !important;
  color: #222222 !important;
  font-weight: 400 !important;
`;

const Header: FC<HeaderProps> = (props) => (
  <HeaderContainer data-qa="clients-header-container">
    <Heading>{props.headingText}</Heading>

    <IncludeInactiveCheckBox
      checked={props.inactiveFilter}
      onChange={() => props.onInactiveFilterChange(!props.inactiveFilter)}
      data-qa="clients-header-include-inactive"
    >
      Include Inactive
    </IncludeInactiveCheckBox>

    {props.showAddButton !== false && (props.showDropdown ? (
      <AddButton onClick={props.openDropdown} title="New Client" />
    ) : (
      <AddButton onClick={props.onAddClick} title={props.addButtonText} />
    ))}
    {props.showAddButton !== false && props.dropdownState && (
      <div className="dots_menu new_client" data-qa="clients-header-new-client-menu">
        <div className="dots_menu_row" onClick={props.onAddClick} data-qa="clients-header-add-manually">
          <span>Add Manually</span>
        </div>

        <div
          className="dots_menu_row"
          onClick={props.clickImportClients}
          data-qa="clients-header-import-quickbooks"
        >
          <span>Import from QuickBooks</span>
        </div>
      </div>
    )}
  </HeaderContainer>
);

export default Header;
